



























































































































































































































import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import moment from "moment";
import store from "@/store";

// @types
import { ExtendedVessel } from "@/types/vessel";
import { Voyage } from "@/types/voyage";

// @modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
const Vessels = getModule(VesselsModule, store);

@Component({})
export default class DateRangeSelect extends Vue {
  @Prop({ default: null }) value!: [string, string] | null;
  @Prop({ default: true }) label!: boolean;
  @Prop({ default: false }) simplifiedMode!: boolean;
  @PropSync("dateRangeType", { default: "AllValues" }) syncDateRangeType!: string;

  // @Data
  isVoyageListLoading = false;
  searchDateRangeStr = "";
  localDateRange: [string, string] | null = null;
  previousLocalDateRange: [string, string] | null = null;
  dataRangeMaskStart = "";
  dataRangeMaskEnd = "";
  lastDaysCount = "";
  datepickerKey = 0;
  voyageList: { name: string; value: string; startDate: Date; endDate: Date }[] = [];
  apiVoyageList: Voyage[] = [];
  DateRangeSelectMenu = {
    state: "All" as "All" | "Datepicker",
    selected: "All" as "All" | "Datepicker",
    isOpen: false,
  };
  dateTypeList: { text: string; value: string }[] = [
    { text: "Between", value: "between" },
    { text: "Last", value: "last" },
  ];
  timePartsSet = {
    start: { hour: false, minute: false },
    end: { hour: false, minute: false },
  };
  dateType: { text: string; value: string } = { text: "Between", value: "between" };
  formatDate = {
    stringify: (date: Date | string) => {
      if (!date) return "";
      // If already a string in YYYY-MM-DDTHH:mm, just return it
      if (typeof date === "string" && moment(date, "YYYY-MM-DDTHH:mm", true).isValid()) {
        return date;
      }
      // Otherwise, try to format as date
      const m = moment(date);
      return m.isValid() ? m.format("YYYY-MM-DDTHH:mm") : "";
    },
    parse: (value: string) => {
      return value ? moment(value, "YYYY-MM-DDTHH:mm").toDate() : null;
    },
  };

  // @Watch
  @Watch("dataRangeMaskStart")
  @Watch("dataRangeMaskEnd")
  onMaskInputChange(): void {
    this.checkAndApplyMaskRange();
  }
  @Watch("dateType")
  onDateTypeChange(newValue: { text: string; value: string }): void {
    if (newValue.value === "between" && Array.isArray(this.value)) {
      if (Array.isArray(this.localDateRange)) {
        this.dataRangeMaskStart = this.localDateRange[0] || "";
        this.dataRangeMaskEnd = this.localDateRange[1] || "";
      } else if (Array.isArray(this.value)) {
        this.dataRangeMaskStart = this.value[0] || "";
        this.dataRangeMaskEnd = this.value[1] || "";
      } else {
        this.dataRangeMaskStart = "";
        this.dataRangeMaskEnd = "";
      }
    }
    if (newValue.value === "last" && Array.isArray(this.value)) {
      const [start, end] = this.value;
      if (start && end) {
        const days = moment.utc(end, "YYYY-MM-DDTHH:mm").diff(moment.utc(start, "YYYY-MM-DDTHH:mm"), "days") + 1;
        this.lastDaysCount = days > 0 ? String(days) : "";
      } else {
        this.lastDaysCount = "";
      }
    }
  }

  @Watch("value", { immediate: true, deep: true })
  onValueChange(newVal: [string, string] | null): void {
    this.localDateRange = Array.isArray(newVal) ? [...newVal] : null;

    if (Array.isArray(newVal)) {
      this.dataRangeMaskStart = newVal[0] ? moment.utc(newVal[0], "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") : "";
      this.dataRangeMaskEnd = newVal[1] ? moment.utc(newVal[1], "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") : "";
      // When a range value exists, mark selection as Datepicker
      this.DateRangeSelectMenu.selected = "Datepicker";
    } else {
      this.dataRangeMaskStart = "";
      this.dataRangeMaskEnd = "";
    }
  }

  @Watch("DateRangeSelectMenu.isOpen")
  onDateRangeSelectMenuOpenChange(isOpen: boolean): void {
    if (isOpen) {
      if (this.simplifiedMode) {
        // In simplified mode, always show datepicker
        this.DateRangeSelectMenu.state = "Datepicker";
        this.DateRangeSelectMenu.selected = "Datepicker";
        // Reset time parts tracking to ensure calendar view is shown
        this.timePartsSet = {
          start: { hour: false, minute: false },
          end: { hour: false, minute: false },
        };
        // Force datepicker to reset to calendar view by clearing and restoring value
        const savedValue = Array.isArray(this.value) ? [...this.value] : null;
        this.localDateRange = null;
        this.$nextTick(() => {
          if (savedValue && Array.isArray(savedValue)) {
            this.localDateRange = [
              savedValue[0] ? moment.utc(savedValue[0], "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") : "",
              savedValue[1] ? moment.utc(savedValue[1], "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") : "",
            ];
            this.dataRangeMaskStart = savedValue[0] || "";
            this.dataRangeMaskEnd = savedValue[1] || "";
          }
        });
        return;
      }
      if (Array.isArray(this.value)) {
        this.localDateRange = [
          this.value[0] ? moment.utc(this.value[0], "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") : "",
          this.value[1] ? moment.utc(this.value[1], "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") : "",
        ];
        this.dataRangeMaskStart = this.value[0] || "";
        this.dataRangeMaskEnd = this.value[1] || "";
      } else {
        this.localDateRange = null;
        this.dataRangeMaskStart = "";
        this.dataRangeMaskEnd = "";
      }
    } else {
      this.localDateRange = null;
      this.dataRangeMaskStart = "";
      this.dataRangeMaskEnd = "";
      // Increment key to force remount datepicker in simplified mode
      if (this.simplifiedMode) {
        this.datepickerKey++;
      }
      setTimeout(() => {
        if (!this.simplifiedMode) {
          this.DateRangeSelectMenu.state = "All";
        }
        if (!this.value || !Array.isArray(this.value) || (!this.value[0] && !this.value[1])) this.DateRangeSelectMenu.selected = this.simplifiedMode ? "Datepicker" : "All";
        else this.DateRangeSelectMenu.selected = "Datepicker";
      }, 200);
    }
  }

  // @Getters
  get vessel(): ExtendedVessel | null {
    if (!Vessels.currentVessel) return null;
    return Vessels.currentVessel;
  }

  get vesselLogDataMinDate(): string {
    if (!this.vessel) return moment.utc().subtract(5, "year").toISOString();
    return this.vessel.logDataMinDate;
  }

  get vesselLogDataMaxDate(): string {
    if (!this.vessel) return moment.utc().toISOString();
    return this.vessel.logDataMaxDate;
  }

  get DateRangeSelectMenuItems(): { name: string; value: string }[] {
    return [
      { name: "All Data Available", value: "All" },
      { name: "Choose Date And Time Range", value: "Datepicker" },
    ];
  }

  get formattedDateRange(): string {
    const val = this.value;
    if (!val || !Array.isArray(val) || val.length !== 2 || (!val[0] && !val[1])) {
      if (this.simplifiedMode || this.DateRangeSelectMenu.state === "Datepicker") return "Choose a Date Range";
      return "All Data Available";
    }
    const [start, end] = val;
    const startStr = start && moment.utc(start, "YYYY-MM-DDTHH:mm", true).isValid() ? moment.utc(start, "YYYY-MM-DDTHH:mm").format("D MMM YYYY HH:mm") : "";
    const endStr = end && moment.utc(end, "YYYY-MM-DDTHH:mm", true).isValid() ? moment.utc(end, "YYYY-MM-DDTHH:mm").format("D MMM YYYY HH:mm") : "";
    if (startStr && endStr) return `${startStr} - ${endStr}`;
    if (startStr) return startStr;
    if (endStr) return endStr;
    return "";
  }

  get dataRangeMaskStartDisplay(): string {
    return this.dataRangeMaskStart ? this.dataRangeMaskStart.replace("T", " ") : "";
  }
  set dataRangeMaskStartDisplay(val: string) {
    this.dataRangeMaskStart = val ? val.replace(" ", "T") : "";
  }

  get dataRangeMaskEndDisplay(): string {
    return this.dataRangeMaskEnd ? this.dataRangeMaskEnd.replace("T", " ") : "";
  }
  set dataRangeMaskEndDisplay(val: string) {
    this.dataRangeMaskEnd = val ? val.replace(" ", "T") : "";
  }

  // @Methods
  applyDateRange(): void {
    let start = "";
    let end = "";

    if (this.dateType.value === "last" && this.lastDaysCount) {
      const days = parseInt(this.lastDaysCount, 10);
      if (days > 0) {
        end = moment.utc().format("YYYY-MM-DDTHH:mm");
        start = moment
          .utc()
          .subtract(days - 1, "days")
          .format("YYYY-MM-DDTHH:mm");
        this.dataRangeMaskStart = start;
        this.dataRangeMaskEnd = end;
      }
      this.syncDateRangeType = "SetPeriod";
    } else if (this.dateType.value === "between") {
      start = moment.utc(this.dataRangeMaskStart, "YYYY-MM-DDTHH:mm").isValid() ? moment.utc(this.dataRangeMaskStart, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") : "";
      end = moment.utc(this.dataRangeMaskEnd, "YYYY-MM-DDTHH:mm").isValid() ? moment.utc(this.dataRangeMaskEnd, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") : "";
      this.syncDateRangeType = "SetPeriod";
    }

    // Always emit the selected range if both are set
    if (start && end) {
      this.$emit("input", [start, end]);
    }
  }

  disableFutureDates(date: Date): boolean {
    // Disable if date is after today
    return date > new Date();
  }

  checkAndApplyMaskRange(): void {
    if (this.dateType.value === "between") {
      const startValid = this.dataRangeMaskStart && moment(this.dataRangeMaskStart, "YYYY-MM-DDTHH:mm", true).isValid();
      const endValid = this.dataRangeMaskEnd && moment(this.dataRangeMaskEnd, "YYYY-MM-DDTHH:mm", true).isValid();
      if (startValid && endValid) {
        this.applyDateRange();
      }
    }
  }

  DateRangeSelectItemClick(item: { name: string; value: string }): void {
    if (item.value === "All") {
      this.$emit("input", null);
      this.DateRangeSelectMenu.state = "All";
      this.DateRangeSelectMenu.selected = "All";
      this.syncDateRangeType = "AllValues";
    } else if (item.value === "Datepicker") {
      this.DateRangeSelectMenu.state = "Datepicker";
      this.DateRangeSelectMenu.selected = "Datepicker";
    }
  }

  onDateRangeChange(value: string[], type: string): void {
    if (Array.isArray(this.localDateRange)) {
      this.dataRangeMaskStart = this.localDateRange[0] || "";
      this.dataRangeMaskEnd = this.localDateRange[1] || "";

      // Determine which index changed by comparing to previous value
      let changedIndex = 0;
      if (this.previousLocalDateRange && Array.isArray(this.previousLocalDateRange) && value.length === 2) {
        if (value[0] !== this.previousLocalDateRange[0]) {
          changedIndex = 0;
        } else if (value[1] !== this.previousLocalDateRange[1]) {
          changedIndex = 1;
        }
      }

      // Mark the changed part as set
      if (type === "hour" || type === "minute") {
        const key = changedIndex === 0 ? "start" : "end";
        this.timePartsSet[key][type] = true;
      }

      // Validate both dates
      const startValid = this.dataRangeMaskStart && moment(this.dataRangeMaskStart, "YYYY-MM-DDTHH:mm", true).isValid();
      const endValid = this.dataRangeMaskEnd && moment(this.dataRangeMaskEnd, "YYYY-MM-DDTHH:mm", true).isValid();

      // Only close if both hour and minute are set for both dates
      if (startValid && endValid && this.timePartsSet.start.hour && this.timePartsSet.start.minute && this.timePartsSet.end.hour && this.timePartsSet.end.minute) {
        this.applyDateRange();
        this.DateRangeSelectMenu.isOpen = false;
        // Reset for next open
        this.timePartsSet = {
          start: { hour: false, minute: false },
          end: { hour: false, minute: false },
        };
      }

      // Update previous value for next change
      this.previousLocalDateRange = [...this.localDateRange];
      this.checkAndApplyMaskRange();
    } else {
      this.dataRangeMaskStart = "";
      this.dataRangeMaskEnd = "";
      this.timePartsSet = {
        start: { hour: false, minute: false },
        end: { hour: false, minute: false },
      };
      this.previousLocalDateRange = null;
    }
  }

  onLastDaysInput(val: string): void {
    this.lastDaysCount = val.replace(/\D/g, "");
    if (this.dateType.value === "last" && this.lastDaysCount && parseInt(this.lastDaysCount, 10) > 0) {
      this.applyDateRange();
    }
  }

  // @Hooks
  async mounted(): Promise<void> {
    if (this.simplifiedMode && (!this.value || !Array.isArray(this.value) || (!this.value[0] && !this.value[1]))) {
      // Initialize with last month date range in simplified mode
      const endDate = moment.utc();
      const startDate = moment.utc().subtract(1, "month");
      const range: [string, string] = [startDate.format("YYYY-MM-DDTHH:mm"), endDate.format("YYYY-MM-DDTHH:mm")];
      this.$emit("input", range);
      this.DateRangeSelectMenu.state = "Datepicker";
      this.DateRangeSelectMenu.selected = "Datepicker";
    }
  }
}
